export default __webpack_public_path__ + "static/media/gallery_06.34862f87.jpg";